import { useQuery } from "react-query";

import { useLicenses } from "~/entity/Licenses/hooks/useLicenses";
import {
  ILicenseEmployeeRowApi,
  ILicensesOverviewParams,
} from "~/entity/Licenses/model/schema";

import { ILicensePositionGroupRow, LicensePositionGroupTariff } from "./types";

const mapTariffType = (
  licenseType: ILicenseEmployeeRowApi["licenseType"],
): LicensePositionGroupTariff | undefined => {
  if (licenseType === "BASE") {
    return "base";
  }

  if (licenseType === "ADDITIONAL") {
    return "additional";
  }

  return undefined;
};

export const usePositionGroupLicenses = (
  params: ILicensesOverviewParams,
  organizationName: string,
) => {
  const { queryKeys, getLicensesEmployees } = useLicenses();

  const query = useQuery({
    queryKey: queryKeys.employees(params),
    queryFn: () => getLicensesEmployees(params),
    enabled:
      (Boolean(params.dealerId) || Boolean(params.organizationId)) &&
      params.instanceId != null,
  });

  const data = query.data?.data;
  const rows: ILicensePositionGroupRow[] =
    data?.level === "employees"
      ? data.rows.map((row) => ({
          id: row.id,
          organizationName,
          employeeId: row.employeeId != null ? String(row.employeeId) : "",
          employeeName: row.employeeName ?? "",
          position: row.positionName ?? "",
          email: row.employeeEmail ?? undefined,
          tariffType: mapTariffType(row.licenseType),
          licenseCost: row.price ? Number(row.price) : undefined,
          status: row.status,
        }))
      : [];

  return {
    ...query,
    rows,
    total: data?.level === "employees" ? data.total : 0,
  };
};
